export abstract class BaseAnalyticsProvider {
	public abstract sendEvent(actionName: string, actionData: any): Promise<void>
}
